<div id="backup-page-title">
  {{ 'PAGES.STAGING.STAGING_FROM_BACKUP_MODAL.TITLE' | translate }}
</div>

<div class="backup-list-container">
  <mat-table id="backup-list" #table [dataSource]="dataSource">
    <ng-container matColumnDef="date">
      <mat-header-cell class="backup-datetime-column" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.DATE' | translate }}
      </mat-header-cell>
      <mat-cell class="backup-datetime-column" *matCellDef="let backup">
        <div class="backup-date">
          {{ backup.dateTime | date }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell class="backup-desc-column" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.DESCRIPTION' | translate }}
      </mat-header-cell>
      <mat-cell class="backup-desc-column" *matCellDef="let backup">
        <div class="truncate-description" [matTooltip]="backup.displayDescription">
          {{ backup.displayDescription }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="fileSystemSize">
      <mat-header-cell class="size-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.FILES' | translate }}
      </mat-header-cell>
      <mat-cell class="size-column-cell" *matCellDef="let backup">
        <div>
          {{ backup.displayFileSystemSize | filesize }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="databaseSize">
      <mat-header-cell class="size-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.DATABASE' | translate }}
      </mat-header-cell>
      <mat-cell class="size-column-cell" *matCellDef="let backup">
        <div>
          {{ backup.displayDatabaseSize | filesize }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="posts">
      <mat-header-cell class="data-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.POSTS' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell" *matCellDef="let backup">
        <div>
          {{ backup.displayNPosts }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="pages">
      <mat-header-cell class="data-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.PAGES' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell" *matCellDef="let backup">
        <div>
          {{ backup.displayNPages }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="plugins">
      <mat-header-cell class="data-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.PLUGINS' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell" *matCellDef="let backup">
        <div>{{ backup.displayNPlugins }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="wpVersion">
      <mat-header-cell class="data-column-cell" *matHeaderCellDef>
        {{ 'PAGES.BACKUPS.TABLE.HEADERS.WP_VERSION' | translate }}
      </mat-header-cell>
      <mat-cell class="data-column-cell" *matCellDef="let backup">
        {{ backup.displayWPVersion }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selection.select(row)"
      [ngClass]="{ 'selected-row': selection.isSelected(row) }"
    ></mat-row>
  </mat-table>

  @if (loading) {
    <mat-spinner class="total-table-spinner" color="accent" mode="indeterminate"></mat-spinner>
  }

  <mat-paginator
    #paginator
    id="paginator-list"
    [length]="numberOfBackups"
    [pageIndex]="0"
    [pageSize]="10"
    [pageSizeOptions]="[10]"
  ></mat-paginator>
</div>
<div class="table-buttons">
  <button class="cancel-button" mat-button [mat-dialog-close]="false" type="button">
    {{ 'PAGES.STAGING.STAGING_FROM_BACKUP_MODAL.BUTTONS.CANCEL' | translate }}
  </button>
  <button
    (click)="createStagingFromBackup()"
    [disabled]="selection.isEmpty()"
    class="action-button"
    color="accent"
    mat-raised-button
    type="button"
    >
    {{ 'PAGES.STAGING.STAGING_FROM_BACKUP_MODAL.BUTTONS.CREATE' | translate }}
  </button>
</div>
